module.exports = __webpack_public_path__ + "static/media/XRMATTDLOD1.46b71002.png";